module.exports = __webpack_public_path__ + "static/media/newsheader.2694aef6.png";